/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Usersessionhuburlclientid5Inputs */

const en_entity_usersessionhuburlclientid5 = /** @type {(inputs: Entity_Usersessionhuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub Client ID`)
};

const de_entity_usersessionhuburlclientid5 = /** @type {(inputs: Entity_Usersessionhuburlclientid5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Session Hub Client ID`)
};

/**
* | output |
* | --- |
* | "User Session Hub Client ID" |
*
* @param {Entity_Usersessionhuburlclientid5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_usersessionhuburlclientid5 = /** @type {((inputs?: Entity_Usersessionhuburlclientid5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Usersessionhuburlclientid5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_usersessionhuburlclientid5(inputs)
	return de_entity_usersessionhuburlclientid5(inputs)
});
export { entity_usersessionhuburlclientid5 as "entity_userSessionHubUrlClientId" }